import React from 'react';

class LexRadio extends React.Component {
  render() {
    const {
      checked,
      onChange,
      label,
      description,
      premium = false,
      name,
      value,
    } = this.props;

    const className = [
      'lex-radio',
      checked ? 'lex-radio--checked' : '',
      premium ? 'lex-radio--premium' : '',
    ].filter(Boolean).join(' ');

    return (
      <label className={className}>
        <input
          type="radio"
          className="lex-toggle__input"
          checked={checked}
          name={name}
          value={value}
          onChange={() => onChange(value)}
        />
        <span className="lex-radio__dot" aria-hidden="true" />
        <span className="lex-radio__label">
          {description ? (
            <>
              <strong>{label}</strong>
              {description}
            </>
          ) : (
            label
          )}
        </span>
      </label>
    );
  }
}

export default LexRadio;
